import React from 'react';
import { FaMapMarkerAlt, FaPhone, FaEnvelope, FaFacebook, FaInstagram } from 'react-icons/fa';

const Footer = () => {
    return (
        <footer className='bottom-0 bg-white text-zinc-900 p-6 mt-10 gap-10 w-full'>
            <div className='container mx-auto flex justify-between'>
                <div>
                    <h3 className='text-xl font-bold text-principal'>Contacto</h3>
                    <p className='mt-2'>
                        <a href="https://www.google.com/maps/search/?api=1&query=1.848879, -76.045627" target='_blank' rel='noopener noreferrer' className='flex items-center font-ubuntu'>
                            <FaMapMarkerAlt className='mr-2 text-principal' />
                            Calle 4 #1B 11, Pitalito Huila
                        </a>
                    </p>
                    <p className='mt-2'>
                        <a href="tel:+573104032213" className='flex items-center font-ubuntu'>
                            <FaPhone className='mr-2 text-principal' />
                            3104032213
                        </a>
                    </p>
                    <p className='mt-2'>
                        <a href="mailto:albaluzramos2@gmail.com" className='flex items-center font-ubuntu'>
                            <FaEnvelope className='mr-2 text-principal' />
                            albaluzramos2@gmail.com
                        </a>
                    </p>
                </div>
                <div className='flex flex-col items-center'>
                    <h3 className='text-xl font-bold text-principal'>Sígueme</h3>
                    <a href='https://www.facebook.com/albita1303' target='_blank' rel='noreferrer' className='mt-4 cursor-pointer text-principal'>
                        <FaFacebook size={30} />
                    </a>
                    <a href='https://www.instagram.com/alba.luz69/' target='_blank' rel='noreferrer' className='mt-5 cursor-pointer text-principal'>
                        <FaInstagram size={30}/>
                    </a>
                </div>
            </div>
        </footer>
    );
}

export default Footer;